import { render } from "./App.vue?vue&type=template&id=c93c1806&class=bg-%5B%230F1014%5D"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c93c1806&lang=css"

import exportComponent from "/home/runner/work/Palmswap-Academy/Palmswap-Academy/academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__